<div class="templat-container">
  <input class="text-box-custom px-3" autocomplete="off" placeholder="Search by name" #search type="text" [formControl]="searchString" />
  <div style="height: 450px; margin: 16px -16px; overflow-x: hidden !important; overflow: auto">
    @if (
      clientGroups.length || !searchString?.value || ownerUserProfile?.name?.toLowerCase().indexOf(searchString?.value?.toLowerCase()) >= 0) {
      <span
        class="static-cards-wrapper"
        >
        @if (
          (!searchString?.value || ownerUserProfile?.name?.toLowerCase().indexOf(searchString?.value?.toLowerCase()) >= 0) &&
          !connectedUserinPolicy &&
          clientGroups.length
          ) {
          <div
            class="static-cards"
            >
            <div
              class="header-body"
              [ngStyle]="{ cursor: !!(ownerUserProfile?.id == data.userId) ? 'not-allowed' : 'pointer' }"
              (click)="$event.stopPropagation(); addLoginUser()"
              >
              <div class="child-container">
                <ngx-avatars
                  size="24"
                  [src]="ownerUserProfile.image"
                  [name]="ownerUserProfile.name"
                  [round]="false"
                  initialsSize="2"
                  cornerRadius="100"
                ></ngx-avatars>
                <p>{{ ownerUserProfile.name | truncateStrPipe : 28 }}</p>
              </div>
            </div>
          </div>
        }
        @if (clientGroups) {
          <div>
            @for (item of clientGroups; track item; let i = $index) {
              @if (item.user_id != ownerUserProfile.id) {
                <div class="static-cards">
                  <div
                    class="header-body"
                    [ngStyle]="{ cursor: !!(item?.user_id == data.userId) ? 'not-allowed' : 'pointer' }"
                    (click)="$event.stopPropagation(); openFolder(item, i)"
                    >
                    <div class="child-container">
                      <ngx-avatars
                        size="24"
                        [src]="item.user_profile_image_url"
                        [name]="item.user_first_middle_name + ' ' + item.user_last_name"
                        [round]="false"
                        initialsSize="2"
                        cornerRadius="100"
                      ></ngx-avatars>
                      <p>
                        {{ item.user_first_middle_name + ' ' + item.user_last_name | truncateStrPipe : 28 }}</p>
                    </div>
                    @if (item.isRunning) {
                      <div class="child-container" style="padding-right: 12px">
                        <p class="checking-permission" style="margin-right: 9px">Checking permission</p>
                        <img class="rotate-spinner" src="assets/images/rotate-gree-icon.svg" />
                      </div>
                    }
                  </div>
                  @if (!item.isAccess) {
                    <div class="message-body">
                      <p class="message-text m-0">
                        {{ item.user_first_middle_name + ' ' + item.user_last_name }} needs permission to access the attached template.
                      </p>
                      <div class="action-body">
                        <button
                          (click)="$event.stopPropagation(); item.isAccess = true; item.isRunning = false"
                          class="Cancel-btn"
                          mat-button
                          [disableRipple]="true"
                          >
                          Cancel
                        </button>
                        <button (click)="$event.stopPropagation(); grantPermission(item, i)" class="give-permission-btn" [disableRipple]="true" mat-button>
                          Share
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
        @if (entitiesItems && data.type == 'entity') {
          <div>
            @for (item of entitiesItems; track item; let i = $index) {
              <div class="static-cards">
                <div class="header-body cursor-pointer" (click)="$event.stopPropagation(); addVaultForm(item, i)">
                  <div class="child-container">
                    <ngx-avatars
                      size="24"
                      [src]="item.profile_image_url"
                      [name]="item.form_name"
                      [round]="false"
                      initialsSize="2"
                      cornerRadius="100"
                    ></ngx-avatars>
                    <p>{{ item.form_name | truncateStrPipe : 38 }}</p>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </span>
    } @else {
      <p style="padding-left: 16px">No Result Found</p>
    }
  </div>
</div>
